import Ferrofluid from '@/components/feature/Ferrofluid';

export default function Hero() {
  return (
    <section id="top" className="relative w-full min-h-screen overflow-hidden bg-black">
      {/* Ferrofluid background */}
      <div className="absolute inset-0 z-0">
        <Ferrofluid
          colors={['#ffffff', '#e5e7eb', '#a3a3a3']}
          speed={0.45}
          scale={1.4}
          turbulence={1.1}
          fluidity={0.12}
          rimWidth={0.22}
          sharpness={2.8}
          shimmer={1.2}
          glow={2.2}
          flowDirection="right"
          opacity={1}
          mouseInteraction
          mouseStrength={0.9}
          mouseRadius={0.08}
          mouseDampening={0.05}
        />
      </div>

      {/* Soft vignette */}
      <div className="absolute inset-0 z-10 pointer-events-none bg-gradient-to-b from-black/30 via-transparent to-black/70"></div>

      {/* Content — pass mouse events through so the fluid reacts under the hero */}
      <div className="relative z-20 w-full min-h-screen flex flex-col items-center justify-center px-6 md:px-10 pointer-events-none">
        {/* Top tag */}
        <div className="absolute top-28 left-1/2 -translate-x-1/2 hidden md:flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 backdrop-blur-md border border-white/10 text-white/70 text-xs tracking-widest uppercase pointer-events-auto">
          <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse"></span>
          Now in private beta · v2.6
        </div>

        <div className="max-w-4xl mx-auto text-center w-full">
          <h1 className="text-white font-light tracking-tight leading-[1.02] text-5xl md:text-7xl lg:text-8xl" style={{ fontFamily: '"Instrument Serif", "Times New Roman", serif' }}>
            Where Innovation<br />Meets Execution
          </h1>

          <p className="mt-8 mx-auto max-w-xl text-white/60 text-base md:text-lg leading-relaxed">
            Once your solution is ready, we ensure a smooth launch with rigorous testing and deployment. Post-launch, we continuously analyze performance.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3 pointer-events-auto">
            <a
              href="#contact"
              className="px-7 py-3.5 rounded-full bg-white text-black text-sm font-medium hover:bg-white/90 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2"
            >
              Get Started for Free
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="#contact"
              className="px-7 py-3.5 rounded-full bg-white/8 border border-white/15 text-white text-sm font-medium hover:bg-white/15 transition-colors whitespace-nowrap cursor-pointer backdrop-blur-md"
            >
              Let's Get Connected
            </a>
          </div>
        </div>
      </div>

      {/* Scroll hint */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center gap-2 text-white/40 text-xs tracking-widest uppercase pointer-events-none">
        <span>Scroll</span>
        <span className="w-px h-10 bg-gradient-to-b from-white/40 to-transparent"></span>
      </div>
    </section>
  );
}